var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrowLeft = function SvgArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "width",
    height: "height",
    fill: "none",
    viewBox: "0 0 20 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m2.16 8.342 5.857 5.857A.72.72 0 1 1 7 15.217L.211 8.43a.72.72 0 0 1-.181-.715A.72.72 0 0 1 .21 7L7 .211a.72.72 0 1 1 1.017 1.018L2.345 6.902h16.318a.72.72 0 1 1 0 1.44z",
    clipRule: "evenodd"
  })));
};
export default SvgArrowLeft;